export default "__VITE_ASSET__TEikW1UG__"